import { useEffect, useState } from 'react';
import instance from '../axios-default';
import useAuth from './useAuth';
import { useDispatch } from 'react-redux';
import { ROLE_NAMES } from '../util/const';
import { easySnackbar } from '../store/Noti/noti.actions';

const useTreatmentOptionForTpApproval = ({ caseId, planId, openExternal }) => {
    const [productMatrixArray, setProductMatrixArray] = useState([]);
    const [defaultCaseType, setDefaultCaseType] = useState({});
    const [isFetchingProductmatrixForDr, setIsFetchingProductmatrixForDr] = useState(false);
    const [optionSelected, setOptionSelected] = useState('');
    const auth = useAuth();
    const { user } = auth;
    const dispatch = useDispatch();

    useEffect(() => {
        try {
            if ([ROLE_NAMES.super_admin, ROLE_NAMES.admin, ROLE_NAMES.distributor].includes(user.role)) return;
            if (!openExternal) return;
            if (!caseId) throw new Error('caseId is required');
            if (!planId) throw new Error('planId is required');
            const fetchProductMatrixForTpApproval = async () => {
                try {
                    setIsFetchingProductmatrixForDr(true);
                    const res = await instance.get(`/productmatrix/productmatrixForDrWithCase/${caseId}/${planId}`);
                    if (res.status === 200 && res.data) {
                        setProductMatrixArray(res.data.pm);
                        setDefaultCaseType(res.data.autoUpgradeOrKeep);
                    }
                } catch (error) {
                    console.error('Error fetching product matrix for TP approval: ', error);
                    throw error;
                } finally {
                    setIsFetchingProductmatrixForDr(false);
                }
            };
            fetchProductMatrixForTpApproval();
        } catch (error) {
            console.error('Error in useTreatmentOptionForTpApproval useEffect: ', error);
            let errorMessage = 'An unexpected error occurred';
            if (error?.message) {
                errorMessage = error.message;
            }
            dispatch(easySnackbar(errorMessage, 'error'));
        }
    }, [openExternal, caseId, planId, user.role]);

    useEffect(() => {
        if (!openExternal) {
            setOptionSelected('');
        }
    }, [openExternal]);

    return { productMatrixArray, defaultCaseType, isFetchingProductmatrixForDr, optionSelected, setOptionSelected };
};

export default useTreatmentOptionForTpApproval;
